import styled from 'styled-components';

const StyledRect = styled.rect<{ $active: boolean }>`
	stroke: rgba(255, 255, 255, 0.1);
	stroke-width: 1px;
	fill: ${({ $active }) => ($active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)')};
	transition:
		opacity 0.3s ease,
		stroke 0.3s ease,
		fill 0.3s ease;
`;

const StyledCircle = styled.circle<{ $active: boolean }>`
	fill: white;
	transform: translateX(${(props) => (props.$active ? 0 : -10)}px);
	transition:
		fill 0.3s ease,
		transform 0.3s ease;
`;

const StyledSvg = styled.svg`
	cursor: pointer;

	&:hover {
		${StyledRect} {
			opacity: 1;
			stroke: white;
			fill: white;
		}

		${StyledCircle} {
			fill: black;
		}
	}
`;

export { StyledCircle, StyledRect, StyledSvg };
